import { AutogenModelNmfcClassOverride, AutogenRowNmfcClassOverride } from "./autogen/AutogenModelNmfcClassOverride";

export class ModelNmfcClassOverride extends AutogenModelNmfcClassOverride<RowNmfcClassOverride> {
	constructor() {
		super(RowNmfcClassOverride);
	}
}

export class RowNmfcClassOverride extends AutogenRowNmfcClassOverride {
}